import React from "react";
import {
  LayoutDashboard,
  Users,
  BookOpen,
  GraduationCap,
  FileText,
  Settings,
  Bell,
  CreditCard,
  Languages,
  BookText,
  ScrollText,
  TestTube,
  LibraryBig,
  Newspaper,
  FolderTree,
  ShieldCheck,
  HelpCircle,
  Info,
  Image,
  PenIcon,
  Ticket,
  Clock,
} from "lucide-react";
import { Person, QuestionAnswer } from "@mui/icons-material";

export interface NavItem {
  name: string;
  icon: React.ReactNode;
  link: string;
  children?: NavItem[];
  showOnlyForNonSuperAdmin?: boolean;
}

export interface SidebarSection {
  title: string;
  items: NavItem[];
}

const TestIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-check-square"
  >
    <path d="M9 11l3 3L22 4"></path>
    <path d="M21 21H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z"></path>
  </svg>
);

export const sidebarNavigation: SidebarSection[] = [
  {
    title: "MENU",
    items: [
      {
        name: "Dashboard",
        icon: <LayoutDashboard className="w-5 h-5" />,
        link: "/",
      },
      {
        name: "Users",
        icon: <Users className="w-5 h-5" />,
        link: "/user",
        children: [
          {
            name: "Students",
            icon: <GraduationCap className="w-5 h-5" />,
            link: "/user",
          },
          {
            name: "Transactions",
            icon: <CreditCard className="w-5 h-5" />,
            link: "/transaction",
          },
          {
            name: "Notifications",
            icon: <Bell className="w-5 h-5" />,
            link: "/send-notification",
          },
          {
            name: "Master Users",
            icon: <Person></Person>,
            link: "/master-users",
          },
        ],
      },
      {
        name: "Master",
        icon: <LibraryBig className="w-5 h-5" />,
        link: "/master",
        children: [
          {
            name: "Language",
            icon: <Languages className="w-5 h-5" />,
            link: "/language",
          },
          {
            name: "Education",
            icon: <BookOpen className="w-5 h-5" />,
            link: "/education",
          },
          {
            name: "Stream",
            icon: <ScrollText className="w-5 h-5" />,
            link: "/stream",
          },
          {
            name: "Subject",
            icon: <BookText className="w-5 h-5" />,
            link: "/subject",
          },
        ],
      },
      {
        name: "Ebook",
        icon: <BookOpen className="w-5 h-5" />,
        link: "/ebook",
      },
      {
        name: "E-paper",
        icon: <Newspaper className="w-5 h-5" />,
        link: "/e-paper",
      },
      {
        name: "Test",
        icon: <TestIcon />,
        link: "/test-series",
        children: [
          {
            name: "Test Series",
            icon: <PenIcon className="w-5 h-5" />,
            link: "/test-series",
          },
          {
            name: "Questions",
            icon: <FileText className="w-5 h-5" />,
            link: "/questions",
          },
          {
            name: "Submission Analysis",
            icon: <ScrollText className="w-5 h-5" />,
            link: "/test-submission-analysis",
          },
        ],
      },
      {
        name: "News Blogs",
        icon: <Newspaper className="w-5 h-5" />,
        link: "/news-blogs",
        children: [
          {
            name: "Category",
            icon: <FolderTree className="w-5 h-5" />,
            link: "/category",
          },
          {
            name: "News Article",
            icon: <Newspaper className="w-5 h-5" />,
            link: "/news-blogs",
          },
        ],
      },
      {
        name: "Settings",
        icon: <Settings className="w-5 h-5" />,
        link: "/settings",
        children: [
          {
            name: "Privacy Policy",
            icon: <ShieldCheck className="w-5 h-5" />,
            link: "/privacy-policy",
          },
          {
            name: "About Us",
            icon: <Info className="w-5 h-5" />,
            link: "/about-us",
          },
          {
            name: "Help",
            icon: <HelpCircle className="w-5 h-5" />,
            link: "/help",
          },
          {
            name: "Banner",
            icon: <Image className="w-5 h-5" />,
            link: "/banner",
          },
          {
            name: "Cron Settings",
            icon: <Clock className="w-5 h-5" />,
            link: "/cron-settings",
            showOnlyForNonSuperAdmin: true,
          },
        ],
      },

      {
        name: "Coupon",
        icon: <Ticket></Ticket>,
        link: "/coupon",
        children: [
          {
            name: "Category",
            icon: <FolderTree className="w-5 h-5" />,
            link: "/coupon-category",
          },
          {
            name: "Coupons",
            icon: <Ticket className="w-5 h-5" />,
            link: "/coupon",
          },
        ],
      },
    ],
  },
];
